export default {"src":"/_next/static/media/subscribe.8ba5f200.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};